module.exports = DOMPurify;